import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { css } from 'styled-components';
import { colorGrey60, colorGrey60WithOpacity, colorGrey70 } from '../../../../../tokens';
export var getOptionListItemOverride = function getOptionListItemOverride(_ref) {
  var isSelected = _ref.isSelected,
      disabled = _ref.item.disabled;
  var result = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        background-color: ", "; // an exception case for the lack of intermediate color\n\n        &:hover {\n            background-color: ", ";\n        }\n    "])), disabled ? colorGrey60WithOpacity : colorGrey70, disabled ? colorGrey60WithOpacity : colorGrey60);

  if (isSelected) {
    result = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n            ", ";\n            background-color: ", ";\n        "])), result, disabled ? colorGrey60WithOpacity : colorGrey60);
  }

  return result;
};